module.exports = {
  url: "/meetings-and-events",
  template: require("raw!templates/meetings-events/meetings-and-events-view.html"),
  controller: MeetingAndEventsController,
  controllerAs: "meetingAndEventsCtrl",
};

function MeetingAndEventsController(
  $scope,
  $state,
  store,
  $window,
  contentful,
  $http,
  Socialshare
) {
  var vm = this;
  $window.scrollTo(0, 0);
  contentful
    .entries("content_type=longPage&sys.id=7bCL1KEt5CwEmKM24qUiyu")
    .then(function (res) {
      console.log("meetings page contentful data", res);
      $scope.meetings = res.data.items[0];
      var seoData = res.data.items[0];
      if (seoData.fields.seoPageTitle) {
        document.title = seoData.fields.seoPageTitle;
      }
      if (seoData.fields.seoPageDescription) {
        var meta = document.getElementsByTagName("meta");
        for (var i = 0; i < meta.length; i++) {
          if (meta[i].name.toLowerCase() === "description") {
            meta[i].content = seoData.fields.seoPageDescription;
          }
        }
      }
    });
  vm.showForm = true;
  vm.showConfirmationLayer = false;
  vm.showErrorLayer = false;

  vm.submitForm = function (formValid) {
    if (formValid) {
      var postUrl = "/api/email";
      var reason = "test";
      if (vm.contactForm.company) {
        vm.company = vm.contactForm.company;
      } else {
        vm.company = "N/A";
      }
      var obj = {
        fromName: vm.contactForm.firstName + " " + vm.contactForm.lastName,
        fromEmail: vm.contactForm.email,
        fromCompany: vm.company,
        toName: "Sales",
        toEmail: "sales@parkcitypeaks.com",
        toCc: "nikki@parkcitypeaks.com",
        toBcc: "hoseasandstrom@gmail.com",
        subject: document.title,
        interest: vm.contactForm.interest,
        phone: vm.contactForm.phone,
        emailBody: vm.contactForm.comments,
      };

      // FAKE FORM POST FOR DEVELOPMENT
      // console.log('valid, emailing ' + obj.toEmail)
      // vm.showConfirmationLayer = true;
      // $timeout(function(){
      //   vm.contactForm = '';
      //   vm.showConfirmationLayer = false;
      // }, 5000);

      $http.post(postUrl, obj).then(
        function success(res) {
          console.log("success: ", res);
          vm.showForm = false;
          vm.showConfirmationLayer = true;
          // $timeout(function() {
          // 	vm.contactForm = '';
          // 	vm.showConfirmationLayer = false;
          // }, 10000);
        },
        function error(err) {
          console.log("error: ", err);
          window.glob = err;
          vm.showErrorLayer = true;
          $timeout(function () {
            vm.contactForm = "";
            vm.showErrorLayer = false;
          }, 5000);
        }
      );
    } else {
      console.log("form invalid");
    }
  };
  setTimeout(function () {
    var elem = document.querySelector(".carousel");
    var flkty = new Flickity(elem, {
      imagesLoaded: true,
      draggable: false,
      percentPostion: false,
      cellAlign: "center",
      wrapAround: true,
      lazyLoad: true,
      pageDots: false,
      autoPlay: true,
    });
  }, 1000);
  vm.trustUrl = "trustUrl";

  trustUrl.$inject = ["$sce"];

  function trustUrl($sce) {
    return function (mediaUrl) {
      return $sce.trustAsResourceUrl(mediaUrl);
    };
  }

  $window.sr = ScrollReveal({ reset: false });
  sr.reveal(".home-load", { duration: 1000 });
  sr.reveal("#cafe", { distance: 0, duration: 1000, scale: 1.5 }, 500);
  sr.reveal("#pool", { distance: 0, duration: 1000, scale: 1.5 }, 500);
  sr.reveal("#fitness", { distance: 0, duration: 1000, scale: 1.5 }, 500);

  // Open overlay when button is clicked
  $(".show-blue").on("click", function () {
    var contentID = $(this).data("target");
    $("#" + contentID).toggleClass("reveal");
    $(this).fadeOut(800, "linear");
  });

  $(".show-white").on("click", function () {
    var contentID = $(this).data("target");
    $("#" + contentID).toggleClass("reveal");
    $(this).fadeOut(800, "linear");
  });

  // Close overlay when the outside of menu is clicked
  $(".hide-blue").on("click", function () {
    $(".overlay.bg-blue")
      .addClass("conceal")
      .delay(300)
      .queue(function () {
        $(".overlay.bg-blue").removeClass("conceal");
        $(".overlay.bg-blue").removeClass("reveal");
        $(this).dequeue();
        $(".show-blue").fadeIn(800, "linear");
      });
  });
  $(".hide-white").on("click", function () {
    $(".overlay.bg-white")
      .addClass("conceal")
      .delay(300)
      .queue(function () {
        $(".overlay.bg-white").removeClass("conceal");
        $(".overlay.bg-white").removeClass("reveal");
        $(this).dequeue();
        $(".show-white").fadeIn(800, "linear");
      });
  });
  vm.socialShare = function (share) {
    if (share === "facebook") {
      Socialshare.share({
        provider: "facebook",
        attrs: {
          socialshareUrl: "https://www.parkcitypeaks.com/meetings-and-events",
          socialshareQuote: "Peaks Hotel | Meetings & Events",
          socialshareMedia:
            "https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png",
          socialsharePopupHeight: "400",
          socialsharePopupWidth: "400",
        },
      });
    } else if (share === "twitter") {
      Socialshare.share({
        provider: "twitter",
        attrs: {
          socialshareUrl: "https://www.parkcitypeaks.com/meetings-and-events",
          socialshareText: "Peaks Hotel | Meetings & Events",
          socialshareMedia:
            "https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png",
          socialsharePopupHeight: "400",
          socialsharePopupWidth: "400",
        },
      });
    } else if (share === "pinterest") {
      Socialshare.share({
        provider: "pinterest",
        attrs: {
          socialshareUrl: "https://www.parkcitypeaks.com/meetings-and-events",
          socialshareText: "Peaks Hotel | Meetings & Events",
          socialshareMedia:
            "https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png",
          socialsharePopupHeight: "400",
          socialsharePopupWidth: "400",
        },
      });
    } else if (share === "email") {
      Socialshare.share({
        provider: "email",
        attrs: {
          "socialshare-subject": "Peaks Hotel | Meetings & Events",
          "socialshare-body": "Take a look at the Peaks Hotel!",
        },
      });
    }
  };
}



// WEBPACK FOOTER //
// ./components/templates/meetings-events/meetings-and-events-controller.js